import React from "react";
import { Search, Map, Rocket, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  icon: Search,
  title: "Vind een Station",
  description: "Gebruik de ZapGO! app om direct de dichtstbijzijnde oplaadlocatie te vinden in uw favoriete café, restaurant of op een evenement."
}, {
  icon: Map,
  title: "Scan & Ontgrendel",
  description: "Scan simpelweg de QR-code op het station om een volledig opgeladen powerbank te ontgrendelen. Geen gedoe met eigen kabels."
}, {
  icon: Rocket,
  title: "Overal Inleveren",
  description: "Klaar met laden? Lever de powerbank in bij elk willekeurig ZapGO! station in de stad. Snel, duurzaam en altijd binnen handbereik."
}];
export default function ThreeStepApproachCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="51959" id="call-to-action" ref={ref} className={`py-16 md:py-24 bg-background transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-4 tracking-tight">
            Nooit meer zonder stroom
          </h2>
          <p className="text-muted-foreground text-xl">
            In drie eenvoudige stappen bent u weer mobiel en volledig opgeladen voor uw volgende avontuur.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
          {steps.map((step, i) => <Card key={i} data-index={i} className="border-white/5 bg-card/30 backdrop-blur-sm hover:bg-card/50 transition-all duration-300 shadow-sm hover:shadow-xl rounded-2xl">
              <CardHeader className="pb-2">
                <div className="w-14 h-14 rounded-2xl bg-primary/20 flex items-center justify-center mb-6 text-primary shadow-[0_0_15px_-3px_rgba(34,197,94,0.3)]">
                  <step.icon className="w-7 h-7" />
                </div>
                <CardTitle className="text-2xl font-bold tracking-tight">
                  {i + 1}. {step.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-base leading-relaxed text-muted-foreground">
                  {step.description}
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>

        <div className="relative overflow-hidden rounded-[2rem] bg-primary px-6 py-12 md:px-12 md:py-16 text-center shadow-[0_0_40px_-10px_rgba(34,197,94,0.4)]">
          <div className="relative z-10 max-w-2xl mx-auto">
            <div className="inline-block px-4 py-1.5 mb-6 rounded-full bg-primary-foreground/10 text-primary-foreground text-sm font-bold uppercase tracking-widest">
              B2B Partner Programma
            </div>
            <h3 className="text-3xl md:text-4xl font-bold text-primary-foreground mb-6 tracking-tight">
              Word een ZapGO! Locatie
            </h3>
            <p className="text-primary-foreground/90 text-lg mb-10 leading-relaxed">
              Verhoog uw omzet en bied uw gasten de service die ze nodig hebben. Neem vandaag contact op voor een gratis station-installatie.
            </p>
            <Button asChild size="lg" variant="secondary" className="font-bold text-lg px-8 py-6 rounded-full shadow-lg hover:shadow-2xl transition-all hover:scale-105">
              <Link to="/PartnersPage">
                Word nu Partner <ArrowRight className="ml-2 w-5 h-5" />
              </Link>
            </Button>
          </div>
          
          {}
          <div className="absolute top-0 left-0 -mt-20 -ml-20 w-64 h-64 bg-white/20 rounded-full blur-[100px] pointer-events-none" />
          <div className="absolute bottom-0 right-0 -mb-20 -mr-20 w-64 h-64 bg-white/20 rounded-full blur-[100px] pointer-events-none" />
        </div>
      </div>
    </section>;
}